import React, { FunctionComponent, ReactElement } from 'react'
import cn from 'classnames'

import styles from './Employee.module.scss'

type EmployeeProps = {
  className?: string
  photo: ReactElement<any>
  name: string
  post: string
}

export const Employee: FunctionComponent<EmployeeProps> = ({
  className,
  photo,
  name,
  post,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.photoWrap}>{photo}</div>
      <div className={styles.name}>{name}</div>
      <div className={styles.post}>{post}</div>
    </div>
  )
}
